import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/account/login.component';
import { ForgotPasswordComponent } from './components/account/forgot-password.component';
import { ResetPasswordComponent } from './components/account/reset-password.component';
import { ResetYourPasswordComponent } from './components/account/reset-your-password.component';
import { CanDeactivateGuard } from './core/guards/can-deactivate-guard.service';

const appRoutes: Routes = [
    //{ path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'account/login', component: LoginComponent },
    { path: 'account/forgot-password', component: ForgotPasswordComponent },
    { path: 'account/reset-password', component: ResetPasswordComponent },
    { path: 'account/reset-your-password', component: ResetYourPasswordComponent },
    { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule) },
    { path: 'audit', loadChildren: () => import('./modules/audit/audit.module').then(m => m.AuditModule) },
    /*{ path: 'admin/:tab', component: AdminComponent },
    { path: 'admin/:tab/:id', component: AdminComponent },
    { path: 'admin/group', component: AdminComponent },*/
];
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {})
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanDeactivateGuard
    ]
})
export class AppRoutingBaseModule { }